import {
  Avatar,
  Flexbox,
  Form,
  ListManager,
  PageHeader,
  Paginator,
  QuickFilter,
  Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import dateMask from '@/lib/masks/date'
import reports from '@/services/api/reports'
import React from 'react'
import { Link } from 'react-router-dom'
import FilterFairs from '../../components/FilterFairs'

function AdoptionsInFairs({ title }) {
  usePageTitle({ title })

  const query = useQuery()
  const { data, loading, error } = useAxiosRequest(
    reports.adoptionsInFairs,
    query,
  )

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Relatório detalhado de adoções realizadas nas feiras"
        subtitle="Lista de adoções confirmadas nas feiras do município e online"
        icon="far fa-heart"
        rightAction={() => <FilterFairs donors={data?.donors} />}
      />
      <QuickFilter
        initialValues={{
          'fair.id_eq': '',
        }}
        title="Filtrar"
        renderForm={() => (
          <>
            <Flexbox.Column className="col-4 mt-2">
              <Form.Group>
                <Form.Label className="label-sm pt-2" htmlFor="fairTitle">
                  Feira
                </Form.Label>
                <Form.ValidationField name="['fair.id_eq']">
                  {({ field }) => (
                    <Form.Select
                      // eslint-disable-next-line react/jsx-props-no-spreading
                      {...field}
                      id="fairTitle"
                      className="select-sm"
                      placeholder="Selecione a feira"
                    >
                      <option value="">Todas</option>
                      {data?.fairs?.map((fair) => (
                        <option key={fair.id} value={fair.id}>
                          {fair.title}
                        </option>
                      ))}
                    </Form.Select>
                  )}
                </Form.ValidationField>
              </Form.Group>
            </Flexbox.Column>
          </>
        )}
      />
      <ListManager count={data?.count || 0} loading={loading} error={error}>
        {Boolean(data) && (
          <>
            <table className="table table-hover text-small">
              <thead>
                <tr>
                  <th>Animal adotado</th>
                  <th>Doador</th>
                  <th>Adotante</th>
                  <th width="200px">Data da adoção</th>
                  <th className="text-right" width="200px">
                    Feira
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.rows.map((item) => (
                  <tr key={item?.adoptionId}>
                    <td>
                      <Link
                        to={`/app/pets/${item?.animalId}`}
                        className="text-dark"
                      >
                        <Avatar
                          avatarSize="sm"
                          className="mr-1"
                          name={item?.animalName}
                          photoURL={item?.animalPhotoURL}
                          alt="Imagem do pet"
                        />
                        {item?.animalName}
                      </Link>
                    </td>
                    <td>
                      <Link
                        to={`/app/petis-users/${item?.donorId}`}
                        className="text-dark"
                      >
                        <Avatar
                          avatarSize="sm"
                          className="mr-1"
                          name={item?.donorFullName}
                          photoURL={item?.donorPhotoURL}
                          alt="Imagem do doador"
                        />
                        {item?.donorFullName}
                      </Link>
                    </td>
                    <td>
                      <Link
                        to={`/app/petis-users/${item?.newTutorId}`}
                        className="text-dark"
                      >
                        <Avatar
                          avatarSize="sm"
                          className="mr-1"
                          name={item?.newTutorFullName}
                          photoURL={item?.newTutorPhotoURL}
                          alt="Imagem do adotante"
                        />
                        {item?.newTutorFullName}
                      </Link>
                    </td>
                    <td>{dateMask(item.adoptedAt, { dateStyle: 'short' })}</td>
                    <td className="text-right text-primary">
                      {item?.fairIsOnline ? (
                        item?.fairTitle
                      ) : (
                        <Link to={`/app/adoption-fairs/${item?.fairId}/pets`}>
                          {item?.fairTitle}
                        </Link>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {Boolean(data) && (
              <div className="my-2">
                <Paginator paginatedList={data} />
              </div>
            )}
          </>
        )}
      </ListManager>
    </Styles.Container>
  )
}

export default AdoptionsInFairs
